import styled, { css } from 'styled-components';

import { breakpoints } from '@shared/constants';

export const NicoleImageWrapper = styled.div`
    display: flex;
    margin-top: 56px;
    width: 127px;

    img {
        width: 100%;
    }

    @media (max-width: ${breakpoints.md}px) {
        margin: 0;
        width: 28px;
    }
`;

export const AvatarAssistantWrapper = styled.div`
    margin-top: 56px;
    width: 120px;

    @media (max-width: ${breakpoints.md}px) {
        margin-top: 0;
        width: 28px;
    }
`;

export const CustomAvatarImage = styled.img(
    ({ theme: { radius } }) => css`
        border-radius: ${radius['50']}%;
        height: 113px;
        position: relative;
        right: -4px;
        top: 4px;
        width: 113px;
        z-index: 99;

        @media (max-width: ${breakpoints.md}px) {
            height: 26px;
            margin: 0;
            right: -1px;
            top: 1px;
            width: 26px;
        }
    `,
);

export const SpeekiLogoIcon = styled.div`
    margin-bottom: 50px;
    position: relative;
    right: -28px;
    top: 28px;
    z-index: 99;

    @media (max-width: ${breakpoints.md}px) {
        height: 26px;
        margin: 0;
        right: -6px;
        top: 6px;
        width: 26px;
    }
`;
